var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonSidebarDocument.jinja');
require('./CommonSidebarDocument.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonSidebar/CommonSidebarDocument.js
// module id = 163
// module chunks = 0